module.exports = __webpack_public_path__ + "static/img/all.5825e23.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/all.png
// module id = /T5W
// module chunks = 1